import Contact from "../components/Contact";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import ParticlesBackground from "../components/ParticlesBackground";
import Offers from "../components/Services/Offers";
const Services = () => {
  return (
    <div>
      <div className="text-white flex flex-col gap-y-10 font-inter">
        <div className="px-8 font-inter bg-bg-primary text-white xl:px-20 2xl:px-60">
          <NavBar />
          <Offers />
          <Contact />
        </div>
        <Footer link="Services" />
      </div>
      <ParticlesBackground id="particles" />
    </div>
  );
};

export default Services;
